package org.example.project.engineSnap

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import org.example.project.dashboard.PopupEngineCard
import org.example.project.dashboard.ContentOffset
import org.example.project.dashboard.DashboardTheme
import org.example.project.settings.LumaticaButton
import org.example.project.settings.LumaticaButtonVariant
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.attributes.maxLength
import org.jetbrains.compose.web.attributes.placeholder
import org.jetbrains.compose.web.css.AlignItems
import org.jetbrains.compose.web.css.Color
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.FlexDirection
import org.jetbrains.compose.web.css.JustifyContent
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.alignItems
import org.jetbrains.compose.web.css.backgroundColor
import org.jetbrains.compose.web.css.border
import org.jetbrains.compose.web.css.color
import org.jetbrains.compose.web.css.display
import org.jetbrains.compose.web.css.flexDirection
import org.jetbrains.compose.web.css.fontSize
import org.jetbrains.compose.web.css.fontWeight
import org.jetbrains.compose.web.css.gap
import org.jetbrains.compose.web.css.height
import org.jetbrains.compose.web.css.justifyContent
import org.jetbrains.compose.web.css.lineHeight
import org.jetbrains.compose.web.css.padding
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.textAlign
import org.jetbrains.compose.web.css.width
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Input
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

@Composable
fun SnapSendDialog(
    loading: Boolean,
    error: String,
    onClose: () -> Unit,
    onSend: (String) -> Unit
) {
    var snapKey by remember { mutableStateOf("") }

    PopupEngineCard(
        windowKey = "snap-send-dialog",
        widthPx = 620,
        heightPx = 320,
        minWidthPx = 560,
        minHeightPx = 280,
        initialX = 340.0,
        initialY = 150.0,
        contentInsetLeft = ContentOffset.LEFT.value.toDouble(),
        contentInsetTop = ContentOffset.TOP.value.toDouble(),
        contentInsetRight = ContentOffset.RIGHT.value.toDouble(),
        contentInsetBottom = ContentOffset.BOTTOM.value.toDouble(),
        onClose = onClose
    ) {
        Div({
            style {
                display(DisplayStyle.Flex)
                flexDirection(FlexDirection.Column)
                justifyContent(JustifyContent.Center)
                alignItems(AlignItems.Center)
                gap(18.px)
                property("padding", "44px 26px 26px")
                height(100.percent)
                color(DashboardTheme.TEXT_LIGHT)
            }
        }) {
            Span({
                style {
                    fontSize(22.px)
                    fontWeight("700")
                    textAlign("center")
                    width(100.percent)
                }
            }) { Text("Snap hinzufügen") }

            Span({
                style {
                    fontSize(15.px)
                    lineHeight("1.6")
                    textAlign("center")
                    width(100.percent)
                }
            }) {
                Text("Bitte gib deinen 10-stelligen SnapKey ein, den du vom Teilnehmer bekommen hast, und bestätige deine Eingabe.")
            }

            Input(InputType.Text, attrs = {
                value(snapKey)
                placeholder("SnapKey")
                maxLength(10)
                onInput { snapKey = it.value.take(10) }
                style {
                    width(240.px)
                    padding(12.px)
                    border(1.px, LineStyle.Solid, Color("rgba(255,255,255,0.12)"))
                    backgroundColor(Color("rgba(255,255,255,0.10)"))
                    color(Color("#F7F7F5"))
                    property("box-sizing", "border-box")
                    property("border-radius", "12px")
                    textAlign("center")
                }
            })

            if (error.isNotBlank()) {
                Div({
                    style {
                        fontSize(13.px)
                        color(Color("#ffd7d7"))
                        textAlign("center")
                    }
                }) { Text(error) }
            }

            Div({
                style {
                    display(DisplayStyle.Flex)
                    justifyContent(JustifyContent.Center)
                    gap(12.px)
                }
            }) {
                LumaticaButton(
                    label = if (loading) "..." else "Snap senden",
                    onClick = { if (!loading && snapKey.length == 10) onSend(snapKey) },
                    variant = LumaticaButtonVariant.Action,
                    enabled = !loading && snapKey.length == 10
                )
            }
        }
    }
}
